export default "__VITE_ASSET__CXvXeVx0__"